import React from 'react';
import * as styles from './PageRowItem.css';

export const PageRowItem: React.FC<React.PropsWithChildren> = ({ children }) => {
  return <div className={styles['page-row-item']}>{children}</div>;
};
